import React from 'react'
import './DedicatedServers.scss'
import Helmet from 'reactor/components/Helmet'
import BreadcrumbWithImage from '../../../../components/BreadcrumbWithImage'
import Features from '../../features/Features'
import SupportSection from '../../support/Support'
import { makeStyles } from '@material-ui/core/styles'
import BreadcrumbImage from 'assets/images/fullserversbackbread.png'
import SSD from 'assets/images/ssdgreen.png'
import Phone from 'assets/images/phonegreen.png'
import SSL from 'assets/images/sslgreen.png'
import Support from 'assets/images/supportgreen.png'
import Payments from 'assets/images/wifigreen.png'
import Transfer from 'assets/images/transfergreen.png'
import PHP from 'assets/images/phpgreen.png'
import SupportImg from 'assets/images/supportfullserver.png'
import ServersTable from '../../ServersTable'
import PageContent from '../../../../components/PageContent'
import Heading from '../../../../components/heading'

const features = [
    {
        title: "أفضل أداء وسرعة",
        content: "سرعة عالية واستقرار كامل دون حدوث أى مشاكل تقنية.",
        img: SSD,
    },
    {
        title: "قلة حدوث المشاكل التقنية",
        content: "بسبب تملكك سيرفر كامل مخصص لموقعك فقط.",
        img: Support,
    },
    {
        title: "ترافيك غير محدود",
        content: "نوفر سيرفرات خاصة ذات جودة عالية تتحمل عدد غير محدودة من الزيارات",
        img: PHP,
    },
    {
        title: "حماية ضد هجمات DDOS",
        content: "حماية من هجمات حجب الخدمة.",
        img: Phone,
    },
    {
        title: "نقل آمن لموقعك",
        content: "يتم النقل بشكل آمن و والتفعيل فى أسرع وقت.",
        img: Support,
    },
    {
        title: "تفعيل خاصية النسخ الاحتياطي",
        content: "ليتم الرجوع اليها في حالة حدوث مشكلة.",
        img: Payments,
    },
    {
        title: "شهادة حماية SSL",
        content: "شهادة الاتصال الآمن توفر لك نقل البيانات بشكل مشفر.",
        img: SSL,
    },
    {
        title: "الدعم الفني",
        content: "لمساعدتك  عند حدوث المشاكل التقنية.",
        img: Transfer,
    },

]

const packagesOptions = [
    'السعر',
    'عدد المعالجات',
    'نوعية المعالج',
    'نظام التشغيل',
    'المساحة',
    'الترافيك',
    'مساحة الذاكرة',
    'الطلب'
];


const packages = [
    {
        packageName: 'الرعد',
        processors: '32 معالج',
        processorType: '2x Intel® Xeon® E5 2620 v4 ',
        os: 'Linux / Centos',
        space: '2x 6 TB SATA or 3x 500 GB SSD ',
        traffic: 'غير محدودة',
        memory: '128 جيجا بايت',
        price: '1299',
        class:"package-3"
    },
    {
        packageName: 'الزلزال',
        processors: ' 40 معالج',
        processorType: ' 2 Xeon E5 2670v2',
        os: 'Linux / Centos',
        space: '3x3 تيرا بايت',
        traffic: 'غير محدودة',
        memory: '256 جيجا بايت',
        price: '1999',
        class:"package-2"
    },
    {
        packageName: 'عرض خاص',
        processors: '8 معالج',
        processorType: '1x Intel® Xeon® E3 1245 v5',
        os: 'Linux / Centos',
        space: '2x500 جيجا بايت',
        traffic: 'غير محدودة',
        memory: '64 جيجا بايت',
        price: '699',
        class:"package-1"
    },
];

export default function DedicatedServers() {
    const color = '#130845'

    const useStyles = makeStyles({
        root: {
            // backgroundColor: color,
            overflowX: 'hidden',
          '& header': {
              backgroundColor: color,
          }
        }
    });

    const classes = useStyles();

    return(
        <>
            <Helmet
                bodyClass={`full__servers ${classes.root}`}
                title="السيرفرات | اكتسب السرعة والكفاءة العالية لموقعك الإلكتروني"
                description="امتلك واحدة من السيرفرات القوية والسريعة تضمن تحميل موقعك الإلكتروني بسرعة مع رواد، خبرة أكثر من 12 عام في السوق السعودي "
             />

            <BreadcrumbWithImage
                text="الخوادم الكاملة"
                subtext="احصل على سيرفر خاص لموقعك الإلكتروني"
                content="اكتسب السرعة والكفاءة العالية لموقعك الإلكتروني عند حجز خادم كامل، يتحمل الزيارات العالية."
                back={BreadcrumbImage}
                backgroundColor={color}
            />

            <div className="content">

                <Features object={features} headingText="لماذا تختار السيرفرات الكاملة؟" />

               <div>
                    <PageContent>
                    <Heading
                        title="متى تختار خادم كامل؟"
                        subtitle="السيرفر الكامل هو الحل الأمثل لك إذا كان موقعك كبير، وتحتاج لتخزين عدد ضخم من البيانات، و الملفات كما يوفر لك الأمان اللازم لبيانات موقعك. والمميز أيضاً أنه يتحمل عدد زيارات عالية لموقعك." 
                    />

                        <h2 className="page__content--heading"></h2>
                    </PageContent>

                    <PageContent>
                        <ServersTable options={packagesOptions} object={packages} />
                    </PageContent>
               </div>

                <SupportSection
                    title="لا تعرف ما هي الباقة <br/> المناسبة لك ؟"
                    content="تواصل معنا لنمنحك المساعدة مجاناً في اختيار الباقة المناسبة لك"
                    img={SupportImg}
                    backgroundColor="#180D5B"
                    color="#fff"
                    buttonBackgroundColor="#723D9D"
                    btnClass="btn-request-dedicatedservers"
                />

            </div>
        </>
    )
}